import React from "react";
import { Divider, makeStyles } from "@material-ui/core";
import { useSelector } from "react-redux";
import { StepperButtons } from "./StepperButtons";
import { StepperHeader } from "./StepperHeader";

const useStyles = makeStyles(
  () => ({
    container: {
      display: "flex",
      flexDirection: "column",
      height: "100%",
      backgroundColor: "#efefef"
      //position: "fixed"
      //paddingBottom: "56px"
    },
    divider: {
      display: "flex",
      flexGrow: 0,
      flexShrink: 1,
      width: "100%"
    },
    pageSpace: {
      display: "flex",
      flexGrow: 1,
      flexShrink: 1
      //overflow: "hidden"
    }
  }),
  {
    name: "MobileStepper"
  }
);

/**
 * @param {{ pages: JSX.Element[] }} props
 * @returns
 */
export function MobileStepper(props) {
  const { pages } = props;
  const classes = useStyles();
  const pageNumber = useSelector((state) => state.pageNumber);
  return (
    <div className={classes.container}>
      <StepperHeader />
      <Divider className={classes.divider} />
      <div className={classes.pageSpace}>{pages[pageNumber]}</div>
      <Divider className={classes.divider} />
      <StepperButtons />
    </div>
  );
}
